function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

function Android() {
  const userAgent = navigator.userAgent || navigator.vendor;

  return /android/i.test(userAgent)
}

// Remove the _blank target on iOS and Android devices, so they open the map
// properly.
document.addEventListener('DOMContentLoaded', function() {
  if (iOS() || Android()) {
    const mapsLinks = document.getElementsByClassName("maps-link");
    for (var i = 0; i < mapsLinks.length; i++) {
      const el = mapsLinks.item(i);
      el.target = "";
    }
  }
})
